import * as bodySegmentation from '@tensorflow-models/body-segmentation';

import { TAny } from 'types';

import { STATE } from 'constants/index';

import { MODEL_BACKEND_MAP } from 'constants/modelBackendMap';

export const setupModel = (model: TAny) => {
  switch (model) {
    case 'BodyPix':
      STATE.model = bodySegmentation.SupportedModels.BodyPix;
      break;
    default:
      alert(model);
      break;
  }

  showBackendConfigs();
};

const showBackendConfigs = () => {
  const backends = MODEL_BACKEND_MAP['BodyPix'];
  STATE.backend = backends[0];
};
